<div class="tertiary-content-header">
  <h4>{{template?.title}}</h4>
</div>
<div class="settings-email-template" *ngIf="!companyLocalization">
  <span class="font-14 font-gray-600" *ngIf="[templateConstant?.review_request, templateConstant?.review_reminder, templateConstant?.review_receipt, templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)">
    {{templateReviewMsgs[templates.key]}}
  </span>
  <div class="sec-nav-header sec-flex-center-center mb-3" *ngIf="excludedTemplates();">
    <ul class="sec-navbar flex-start-center">
      <li class="sec-navbar-item" [ngClass]="{'active': activeTab === 0}" (click)="setActiveTab(0)">
        <span class="sec-navbar-link">Email</span>
      </li>

      <li *ngIf="template.key !== templateConstant.email_campaign" class="sec-navbar-item"
        [ngClass]="{'active': activeTab === 1}" (click)="setActiveTab(1)">
        <span class="sec-navbar-link">SMS</span>
      </li>
    </ul>
  </div>

  <!-- Start Email Template -->
  <form class="ui-g company-profile-form" [hidden]="activeTab === 1" (ngSubmit)="onSubmit()" #appointmentForm="ngForm">
    <div class="ui-g-12 template-input" *ngIf="excludedTemplates();">
      <label for="templateSubject" class="">Subject</label>
      <div class="form-group" *ngIf="template.key !== 'GOOGLE_REVIEW'">
        <input id="templateSubject" type="text" name="templateSubject" [(ngModel)]="templates.new.subject"
          (focus)="setFocus('subject')" #templateSubject required />
      </div>

      <div class="form-group" *ngIf="template.key === 'GOOGLE_REVIEW'">
        <input id="templateSubject" type="text" name="templateSubject" maxlength="45"
          [(ngModel)]="templates.new.subject" (focus)="setFocus('subject')" #templateSubject required />
      </div>
    </div>

    <div class="ui-g-12">
      <label for="templateContent" class="" *ngIf="excludedTemplates()">Message</label>
      <div class="form-group">
        <div class="template-view p-2">
          <div class="template flex-column flex-start" *ngIf="templates.key !== 'GOOGLE_REVIEW'">
            <!-- Start Header -->
            <header class="flex-between-center template-bg p-4">
              <div class="header-logo flex-center-center">
                <img [src]="company.logo" *ngIf="company.logo" [alt]="company.name">
              </div>
              <div class="header-info flex-center-start flex-column">
                <span class="font-600">{{company.name}}</span>
                <span>{{company?.address?.addLine1}}</span>
                <span>
                  {{company?.address?.city}}, {{company?.address?.stateCode}}, {{company?.address?.country}}
                  {{company?.address?.zip}}
                </span>
                <span>{{company?.phone | mask: '(000) 000-0000'}}</span>
                <span class="highlight">{{company.website}}</span>
              </div>
            </header>
            <!-- End Header -->

            <!-- Start Content -->
            <section [ngClass]="!excludedTemplates() ? 'template-long-textarea' : ''"
              *ngIf="![templateConstant?.disclaimer, templateConstant?.invDisclaimer, templateConstant?.warrantyDisclaimer, templateConstant?.tireWarrantyPolicy].includes(templates.key)">
              <textarea id="templateContent" placeholder="Message body" class="content p-4" name="templateContent"
                maxlength="2000" [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                required></textarea>
            </section>

            <section
              [ngClass]="'template-long-textarea'"
              *ngIf="[templateConstant?.disclaimer, templateConstant?.invDisclaimer, templateConstant?.warrantyDisclaimer,  templateConstant?.tireWarrantyPolicy].includes(templates.key)">
              <textarea id="templateContent" placeholder="Message body" class="content p-4" name="templateContent"
                [rows]="templates.key === templateConstant?.reminder ? 7: 5" [(ngModel)]="templates.new.contents"
                (focus)="setFocus('contents')" #templateTextArea required></textarea>
            </section>
            <!-- End Content -->

            <!-- Start Footer -->
            <div
              *ngIf="[templateConstant?.reminder, templateConstant?.confirmation, templateConstant?.reschedule].includes(templates.key)"
              class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm mr-3">
                  Confirm
                </button>
                <button disabled type="button" class="disabled action action-cancel">
                  Cancel
                </button>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.replyConfirm" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-cancel">
                  Cancel Appointment
                </button>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.setPassword" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-cancel">
                  Set Password
                </button>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.resetPassword" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-cancel">
                  Reset Password
                </button>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.welcome" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-cancel">
                  Open Autoleap
                </button>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.inspection" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  View Inspection
                </button>
              </footer>
            </div>

            <div
              *ngIf="[templateConstant?.estimate, templateConstant?.estimate_approval_reminder].includes(templates.key)"
              class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  View Estimate
                </button>
              </footer>
            </div>

            <div *ngIf="[templateConstant?.invoice, templateConstant?.invoice_vehicle_pickup].includes(templates.key)"
              class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  View Invoice
                </button>
              </footer>
            </div>

            <div
              *ngIf="isPayrixConnected && [templateConstant?.invoice, templateConstant?.invoice_vehicle_pickup].includes(templates.key)"
              class="pl-4 pb-2 pt-2 ">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  Pay Now
                </button>
              </footer>
            </div>

            <!-- button on view deposit -->
            <div
              *ngIf="[templateConstant?.estimateDeposit, templateConstant?.estimateDepositReminder].includes(templates.key)"
              class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  View Estimate
                </button>
              </footer>
            </div>

            <div
              *ngIf="[templateConstant?.estimateDeposit, templateConstant?.estimateDepositReminder].includes(templates.key)"
              class="pl-4 pb-2 pt-2 ">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  Pay Deposit
                </button>
              </footer>
            </div>
            <!-- button on view deposit end -->

            <div *ngIf="templates.key === templateConstant?.receipt" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  View Receipt
                </button>
              </footer>
            </div>

            <div *ngIf=" templates.key === templateConstant?.review" class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm">
                  View Receipt
                </button>
              </footer>
            </div>

            <div
              *ngIf="[templateConstant?.review_request, templateConstant?.review_reminder, templateConstant?.review_receipt, templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)"
              class="pl-4 pb-2 pt-2">
              <footer class="action-group">
                <button disabled type="button" class="disabled action action-confirm" [ngClass]="{'width-182px': [templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)}">
                  <i class="fa-google fab font-14 font-white mr-1" *ngIf="[templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)"></i>
                  {{([templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)) ? 'Give Review on Google' : 'Review'}}
                </button>
              </footer>
            </div>

            <div class="pl-0 mb-4 pt-0 content footer flex-column flex-center-start">
              <div class="scroll"></div>
              <textarea id="footer" class="content pl-4 pr-4 pt-2 pb-2" placeholder="Footer" name="footer"
                maxlength="500" [(ngModel)]="templates.new.footer" [rows]="3" (focus)="setFocus('footer')"
                #templateFooter></textarea>
            </div>
            <!-- End Footer -->
          </div>

          <!-- Google Review Section Starts -->
          <div class="template flex-column flex-start google-review-wrapper" *ngIf="templates.key === 'GOOGLE_REVIEW'">
            <div class="google-review-inner">
              <!-- Start Content -->
              <section>
                <div class="form-group mb-2">
                  <input id="templateSubject" class="google-review-subject" type="text" name="templateSubject"
                    maxlength="45" [(ngModel)]="templates.new.subject" (focus)="setFocus('subject')" #templateSubject
                    required />
                </div>

                <textarea id="templateContent" placeholder="Message body" class="content p-4 google-review-message"
                  name="templateContent" maxlength="300" [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                  [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                  required></textarea>

                <div class="text-center mt-2 goolge-color-button">
                  <button disabled type="button" class="disabled action action-confirm">
                    <div class="google-color-wrapper mr-1">
                      <i class="fab fa-google"></i>
                    </div>
                    Review us on Google
                  </button>
                </div>
              </section>
              <!-- End Content -->
            </div>
          </div>
          <!-- Google Review Section Ends -->

          <div>
            <ul class="tag-list">
              <li class="tag-item" *ngFor="let tag of tags" (click)="handleInsertTag(tag.value)">{{tag.label}}</li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <div class="ui-g-12 text-right">
      <button class="btn btn-secondary btn-submit mr-2" type="button" (click)="restoreDefault()">
        Restore Default
      </button>

      <button [disabled]="!appointmentForm.valid" class="btn btn-primary btn-submit" type="submit">
        Save
      </button>
    </div>
  </form>
  <!-- End Email Template -->


  <!-- Start SMS Template -->
  <form [hidden]="activeTab === 0" class="ui-g company-profile-form" (ngSubmit)="onSubmit()" #appointmentForm="ngForm">
    <div class="ui-g-12">
      <label for="templateContent" class="" *ngIf="excludedTemplates()">Message</label>
      <div class="form-group" pTooltip="This text can be edited from email template." tooltipPosition="top">
        <div class="template-view p-2">
          <div class="template flex-column flex-start">
            <!-- Start Content -->
            <section>
              <textarea id="templateContent" placeholder="Message body"
                pTooltip="This text can be edited from email template." class="content p-4 not-allowed"
                name="templateContent" maxlength="2000" [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                [disabled]="true" [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                required></textarea>
            </section>
            <!-- End Content -->

            <!-- Start Footer -->
            <!-- New Appointment -->
            <div *ngIf="
              templates.key === templateConstant?.confirmation ||
              templates.key === templateConstant?.reschedule ||
              templates.key === templateConstant?.reminder" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">Reply "1" to confirm, "0" to cancel</p>
              </footer>
            </div>

            <!-- Confirm Appointment -->
            <div *ngIf="templates.key === templateConstant?.replyConfirm" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">Reply "0" to cancel</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.setPassword" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[set_password_link]</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.resetPassword" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[reset_password_link]</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.welcome" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[autoleap_app_link]</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.inspection" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[view_inspection_link]</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.estimate_approval_reminder"
              class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[view_estimate_link]</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.estimate" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[view_estimate_link]</p>
              </footer>
            </div>

            <div
              *ngIf="templates.key === templateConstant?.invoice || templates.key === templateConstant?.invoice_vehicle_pickup"
              class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[view_invoice_link]</p>
              </footer>
            </div>

            <div
              *ngIf="templates.key === templateConstant?.review_request || templates.key === templateConstant?.review_reminder || templates.key === templateConstant?.review_request_google || templates.key === templateConstant?.review_reminder_google"
              class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[view_review_link]</p>
              </footer>
            </div>

            <div *ngIf="templates.key === templateConstant?.receipt" class="not-allowed pl-4 pb-2 pt-2">
              <footer class="action-group">
                <p class="m-0">[view_receipt_link]</p>
              </footer>
            </div>


            <div class="pl-0 mb-4 pt-0 content footer flex-column flex-center-start not-allowed">
              <div class="scroll"></div>
              <textarea id="smsContents" class="content pl-4 pr-4 pt-2 pb-2" name="smsFooter" maxlength="500"
                placeholder="Footer" [(ngModel)]="templates.new.smsFooter" [rows]="3" (focus)="setFocus('smsFooter')"
                #smsFooter></textarea>
            </div>
            <!-- End Footer -->
          </div>

          <div>
            <ul class="tag-list">
              <li class="tag-item" *ngFor="let tag of tags" (click)="handleInsertTag(tag.value)">{{tag.label}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-12 text-right">
      <button class="btn btn-secondary btn-submit mr-2" type="button" (click)="restoreDefault()">
        Restore Default
      </button>
      <button [disabled]="!appointmentForm.valid" class="btn btn-primary btn-submit" type="submit">
        Save
      </button>
    </div>
  </form>
  <!-- End SMS Template -->
</div>

<!-- English tab content starts-->
<div class="settings-email-template" *ngIf="companyLocalization">
  <span class="font-14 font-gray-600" *ngIf="[templateConstant?.review_request, templateConstant?.review_reminder, templateConstant?.review_receipt, templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)">
    {{templateReviewMsgs[templates.key]}}
  </span>
  <p-tabView (onChange)="handleChange($event)">
    <p-tabPanel header="English" [selected]="true">
      <div class="english-tab-wrapper language-wrapper">
        <div class="sec-nav-header sec-flex-center-center mb-3" *ngIf="excludedTemplates();">
          <ul class="sec-navbar flex-start-center">
            <li class="sec-navbar-item" [ngClass]="{'active': activeTab === 0}" (click)="setActiveTab(0)">
              <span class="sec-navbar-link">Email</span>
            </li>

            <li *ngIf="template.key !== templateConstant.email_campaign" class="sec-navbar-item"
              [ngClass]="{'active': activeTab === 1}" (click)="setActiveTab(1)">
              <span class="sec-navbar-link">SMS</span>
            </li>
          </ul>
        </div>

        <div class="tabs-content-wrapper">
          <!-- Start Email Template -->
          <form class="ui-g company-profile-form" [hidden]="activeTab === 1" (ngSubmit)="onSubmit()"
            #appointmentForm="ngForm">
            <div class="ui-g-12 template-input" *ngIf="excludedTemplates();">
              <label for="templateSubject">{{'Subject' | translate}}</label>
              <div class="form-group" *ngIf="template.key !== 'GOOGLE_REVIEW'">
                <input id="templateSubject" type="text" name="templateSubject" [(ngModel)]="templates.new.subject"
                  (focus)="setFocus('subject')" #templateSubject required />
              </div>

              <div class="form-group" *ngIf="template.key === 'GOOGLE_REVIEW'">
                <input id="templateSubject" type="text" name="templateSubject" maxlength="45"
                  [(ngModel)]="templates.new.subject" (focus)="setFocus('subject')" #templateSubject required />
              </div>
            </div>

            <div class="ui-g-12">
              <label for="templateContent" class="" *ngIf="excludedTemplates()">Message</label>
              <div class="form-group">
                <div class="template-view">
                  <div class="template flex-column flex-start" *ngIf="templates.key !== 'GOOGLE_REVIEW'">
                    <!-- Start Header -->
                    <header class="flex-between-center template-bg p-4">
                      <div class="header-logo flex-center-center">
                        <img [src]="company.logo" *ngIf="company.logo" [alt]="company.name">
                      </div>
                      <div class="header-info flex-center-start flex-column">
                        <span class="font-600">{{company.name}}</span>
                        <span>{{company?.address?.addLine1}}</span>
                        <span>
                          {{company?.address?.city}}, {{company?.address?.stateCode}}, {{company?.address?.country}}
                          {{company?.address?.zip}}
                        </span>
                        <span>{{company?.phone | mask: '(000) 000-0000'}}</span>
                        <span class="highlight">{{company.website}}</span>
                      </div>
                    </header>
                    <!-- End Header -->

                    <!-- Start Content -->
                    <section [ngClass]="!excludedTemplates() ? 'template-long-textarea' : ''">
                      <textarea
                      *ngIf="![templateConstant?.disclaimer, templateConstant?.invDisclaimer, templateConstant?.warrantyDisclaimer, templateConstant?.tireWarrantyPolicy].includes(templates.key)"
                       id="templateContent" placeholder="Message body" class="content p-4"
                        name="templateContent" maxlength="2000"
                        [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                        [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                        required></textarea>
                    </section>
                    <!-- End Content -->

                    <!-- Start Content -->
                    <section [ngClass]="'template-long-textarea'">
                      <textarea
                      *ngIf="[templateConstant?.disclaimer, templateConstant?.invDisclaimer, templateConstant?.warrantyDisclaimer, templateConstant?.tireWarrantyPolicy].includes(templates.key)"
                       id="templateContent" placeholder="Message body" class="content p-4"
                        name="templateContent"
                        [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                        [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                        required></textarea>
                    </section>
                    <!-- End Content -->

                    <!-- Start Footer -->
                    <div
                      *ngIf="[templateConstant?.reminder, templateConstant?.confirmation, templateConstant?.reschedule].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm mr-3">
                          {{'Confirm' | translate}}
                        </button>
                        <button disabled type="button" class="disabled action action-cancel">

                          {{'Cancel' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.replyConfirm" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          {{'Cancel Appointment' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.setPassword" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          {{'Set Password' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.resetPassword" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          {{'Reset Password' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.welcome" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          {{'Open Autoleap' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.inspection" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'View Inspection' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.estimate, templateConstant?.estimate_approval_reminder].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'View Estimate' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.invoice, templateConstant?.invoice_vehicle_pickup].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'View Invoice' | translate}}
                        </button>
                      </footer>
                    </div>

                    <!-- button on view deposit -->
                    <div
                      *ngIf="[templateConstant?.estimateDeposit, templateConstant?.estimateDepositReminder].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'View Estimate' | translate}}
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.estimateDeposit, templateConstant?.estimateDepositReminder].includes(templates.key)"
                      class="pl-4 pb-2 pt-2 ">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'Pay Deposit' | translate}}
                        </button>
                      </footer>
                    </div>
                    <!-- button on view deposit end -->

                    <div
                      *ngIf="[templateConstant?.invoice, templateConstant?.invoice_vehicle_pickup].includes(templates.key)"
                      class="pl-4 pb-2 pt-2 ">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'Pay Now' | transplate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.receipt" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'View Receipt'| translate}}
                        </button>
                      </footer>
                    </div>

                    <div *ngIf=" templates.key === templateConstant?.review" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          {{'View Receipt'| translate}}
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.review_request, templateConstant?.review_reminder, templateConstant?.review_receipt, templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm" [ngClass]="{'width-182px': [templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)}">
                          <i class="fa-google fab font-14 font-white mr-1" *ngIf="[templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)"></i>
                          {{(([templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)) ? 'Give Review on Google' : 'Review') | translate}}
                        </button>
                      </footer>
                    </div>

                    <div class="pl-0 mb-4 pt-0 content footer flex-column flex-center-start">
                      <div class="scroll"></div>
                      <textarea id="footer" class="content pl-4 pr-4 pt-2 pb-2" placeholder="Footer" name="footer"
                        maxlength="500" [(ngModel)]="templates.new.footer" [rows]="3" (focus)="setFocus('footer')"
                        #templateFooter></textarea>
                    </div>
                    <!-- End Footer -->
                  </div>

                  <!-- Google {{'Review' | translate}} Section Starts -->
                  <div class="template flex-column flex-start google-review-wrapper"
                    *ngIf="templates.key === 'GOOGLE_REVIEW'">
                    <div class="google-review-inner">
                      <!-- Start Content -->
                      <section>
                        <div class="form-group mb-2">
                          <input id="templateSubject" class="google-review-subject" type="text" name="templateSubject"
                            maxlength="45" [(ngModel)]="templates.new.subject" (focus)="setFocus('subject')"
                            #templateSubject required />
                        </div>

                        <textarea id="templateContent" placeholder="Message body"
                          class="content p-4 google-review-message" name="templateContent" maxlength="300"
                          [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                          [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                          required></textarea>

                        <div class="text-center mt-2 goolge-color-button">
                          <button disabled type="button" class="disabled action action-confirm">
                            <div class="google-color-wrapper mr-1">
                              <i class="fab fa-google"></i>
                            </div>
                            {{'Review us on Google' | translate}}
                          </button>
                        </div>
                      </section>
                      <!-- End Content -->
                    </div>
                  </div>
                  <!-- Google {{'Review' | translate}} Section Ends -->

                  <div>
                    <ul class="tag-list">
                      <li class="tag-item" *ngFor="let tag of tags" (click)="handleInsertTag(tag.value)">{{tag.label}}
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>

            <div class="ui-g-12 text-right">
              <button class="btn btn-secondary btn-submit mr-2" type="button" (click)="restoreDefault()">
                {{'Restore Default' | translate}}
              </button>

              <button [disabled]="!appointmentForm.valid" class="btn btn-primary btn-submit" type="submit">
                Save
              </button>
            </div>
          </form>
          <!-- End Email Template -->


          <!-- Start SMS Template -->
          <form [hidden]="activeTab === 0" class="ui-g company-profile-form" (ngSubmit)="onSubmit()"
            #appointmentForm="ngForm">
            <div class="ui-g-12">
              <label for="templateContent" class="" *ngIf="excludedTemplates()">Message</label>
              <div class="form-group" pTooltip="This text can be edited from email template." tooltipPosition="top">
                <div class="template-view">
                  <div class="template flex-column flex-start">
                    <!-- Start Content -->
                    <section>
                      <textarea id="templateContent" placeholder="Message body"
                        pTooltip="This text can be edited from email template." class="content p-4 not-allowed"
                        name="templateContent" maxlength="2000"
                        [rows]="templates.key === templateConstant?.reminder ? 7: 5" [disabled]="true"
                        [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                        required></textarea>
                    </section>
                    <!-- End Content -->

                    <!-- Start Footer -->
                    <!-- New Appointment -->
                    <div *ngIf="
          templates.key === templateConstant?.confirmation ||
          templates.key === templateConstant?.reschedule ||
          templates.key === templateConstant?.reminder" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">{{'Reply "1" to confirm, "0" to cancel' | translate}}</p>
                      </footer>
                    </div>

                    <!-- Confirm Appointment -->
                    <div *ngIf="templates.key === templateConstant?.replyConfirm" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">{{'Reply "0" to cancel' | translate}}</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.setPassword" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[set_password_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.resetPassword" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[reset_password_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.welcome" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[autoleap_app_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.inspection" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_inspection_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.estimate_approval_reminder"
                      class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_estimate_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.estimate" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_estimate_link]</p>
                      </footer>
                    </div>

                    <div
                      *ngIf="templates.key === templateConstant?.invoice || templates.key === templateConstant?.invoice_vehicle_pickup"
                      class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_invoice_link]</p>
                      </footer>
                    </div>

                    <div
                      *ngIf="templates.key === templateConstant?.review_request || templates.key === templateConstant?.review_reminder || templates.key === templateConstant?.review_request_google || templates.key === templateConstant?.review_reminder_google"
                      class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_review_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.receipt" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_receipt_link]</p>
                      </footer>
                    </div>


                    <div class="pl-0 mb-4 pt-0 content footer flex-column flex-center-start not-allowed">
                      <div class="scroll"></div>
                      <textarea id="smsContents" class="content pl-4 pr-4 pt-2 pb-2" name="smsFooter" maxlength="500"
                        placeholder="Footer" [(ngModel)]="templates.new.smsFooter" [rows]="3"
                        (focus)="setFocus('smsFooter')" #smsFooter></textarea>
                    </div>
                    <!-- End Footer -->
                  </div>

                  <div>
                    <ul class="tag-list">
                      <li class="tag-item" *ngFor="let tag of tags" (click)="handleInsertTag(tag.value)">{{tag.label}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g-12 text-right">
              <button class="btn btn-secondary btn-submit mr-2" type="button" (click)="restoreDefault()">
                {{'Restore Default' | translate}}
              </button>
              <button [disabled]="!appointmentForm.valid" class="btn btn-primary btn-submit" type="submit">
                Save
              </button>
            </div>
          </form>
          <!-- End SMS Template -->
        </div>
      </div>
    </p-tabPanel>

    <!-- french tab content starts-->
    <p-tabPanel header="French">
      <div class="french-tab-wrapper language-wrapper">
        <div class="sec-nav-header sec-flex-center-center mb-3" *ngIf="excludedTemplates();">
          <ul class="sec-navbar flex-start-center">
            <li class="sec-navbar-item" [ngClass]="{'active': activeTab === 0}" (click)="setActiveTab(0)">
              <span class="sec-navbar-link">Email</span>
            </li>

            <li *ngIf="template.key !== templateConstant.email_campaign" class="sec-navbar-item"
              [ngClass]="{'active': activeTab === 1}" (click)="setActiveTab(1)">
              <span class="sec-navbar-link">SMS</span>
            </li>
          </ul>
        </div>

        <div class="tabs-content-wrapper">
          <!-- Start Email Template -->
          <form class="ui-g company-profile-form" [hidden]="activeTab === 1" (ngSubmit)="onSubmit()"
            #appointmentForm="ngForm">
            <div class="ui-g-12 template-input" *ngIf="excludedTemplates();">
              <label for="templateSubject" class="">{{'subject' | translate}}</label>
              <div class="form-group" *ngIf="template.key !== 'GOOGLE_REVIEW'">
                <input id="templateSubject" type="text" name="templateSubject" [(ngModel)]="templates.new.subject"
                  (focus)="setFocus('subject')" #templateSubject required />
              </div>

              <div class="form-group" *ngIf="template.key === 'GOOGLE_REVIEW'">
                <input id="templateSubject" type="text" name="templateSubject" maxlength="45"
                  [(ngModel)]="templates.new.subject" (focus)="setFocus('subject')" #templateSubject required />
              </div>
            </div>

            <div class="ui-g-12">
              <label for="templateContent" class="">{{'message' | translate}}</label>
              <div class="form-group">
                <div class="template-view">
                  <div class="template flex-column flex-start" *ngIf="templates.key !== 'GOOGLE_REVIEW'">
                    <!-- Start Header -->
                    <header class="flex-between-center template-bg p-4">
                      <div class="header-logo flex-center-center">
                        <img [src]="company.logo" *ngIf="company.logo" [alt]="company.name">
                      </div>
                      <div class="header-info flex-center-start flex-column">
                        <span class="font-600">{{company.name}}</span>
                        <span>{{company?.address?.addLine1}}</span>
                        <span>
                          {{company?.address?.city}}, {{company?.address?.stateCode}}, {{company?.address?.country}}
                          {{company?.address?.zip}}
                        </span>
                        <span>{{company?.phone | mask: '(000) 000-0000'}}</span>
                        <span class="highlight">{{company.website}}</span>
                      </div>
                    </header>
                    <!-- End Header -->

                    <!-- Start Content -->
                    <section [ngClass]="!excludedTemplates() ? 'template-long-textarea' : ''">
                      <textarea
                      *ngIf="![templateConstant?.disclaimer, templateConstant?.invDisclaimer, templateConstant?.warrantyDisclaimer, templateConstant?.tireWarrantyPolicy].includes(templates.key)"
                      id="templateContent" placeholder="Message body" class="content p-4"
                        name="templateContent" maxlength="2000"
                        [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                        [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                        required></textarea>
                    </section>
                    <!-- End Content -->

                    <!-- Start Content -->
                    <section [ngClass]="'template-long-textarea'">
                      <textarea
                      *ngIf="[templateConstant?.disclaimer, templateConstant?.invDisclaimer, templateConstant?.warrantyDisclaimer, templateConstant?.tireWarrantyPolicy].includes(templates.key)"
                      id="templateContent" placeholder="Message body" class="content p-4"
                        name="templateContent"
                        [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                        [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                        required></textarea>
                    </section>
                    <!-- End Content -->

                    <!-- Start Footer -->
                    <div
                      *ngIf="[templateConstant?.reminder, templateConstant?.confirmation, templateConstant?.reschedule].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm mr-3 text-capitalize">
                          Confirmer
                        </button>
                        <button disabled type="button" class="disabled action action-cancel text-capitalize">
                          Annuler
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.replyConfirm" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel pb-2 pt-2">
                          Annuler le rendez-vous
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.setPassword" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          Définir le mot de passe
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.resetPassword" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          Réinitialiser le mot de passe
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.welcome" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-cancel">
                          Ouvrir Autoleap
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.inspection" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Voir l'inspection
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.estimate, templateConstant?.estimate_approval_reminder].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Voir l'estimation
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.invoice, templateConstant?.invoice_vehicle_pickup].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Voir la facture
                        </button>
                      </footer>
                    </div>

                    <!-- button on view deposit -->
                    <div
                      *ngIf="[templateConstant?.estimateDeposit, templateConstant?.estimateDepositReminder].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Voir l'estimation
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.estimateDeposit, templateConstant?.estimateDepositReminder].includes(templates.key)"
                      class="pl-4 pb-2 pt-2 ">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Payer un acompte
                        </button>
                      </footer>
                    </div>
                    <!-- button on view deposit end -->

                    <div
                      *ngIf="[templateConstant?.invoice, templateConstant?.invoice_vehicle_pickup].includes(templates.key)"
                      class="pl-4 pb-2 pt-2 ">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Payer maintenant
                        </button>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.receipt" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Voir le reçu
                        </button>
                      </footer>
                    </div>

                    <div *ngIf=" templates.key === templateConstant?.review" class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm">
                          Voir le reçu
                        </button>
                      </footer>
                    </div>

                    <div
                      *ngIf="[templateConstant?.review_request, templateConstant?.review_reminder, templateConstant?.review_receipt, templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)"
                      class="pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <button disabled type="button" class="disabled action action-confirm" [ngClass]="{'w-auto': [templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)}">
                          <i class="fa-google fab font-14 font-white mr-1" *ngIf="[templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)"></i>
                          {{([templateConstant?.review_request_google, templateConstant?.review_reminder_google, templateConstant?.review_receipt_google].includes(templates.key)) ? 'Donner un avis sur Google' : 'Revoir'}}
                        </button>
                      </footer>
                    </div>

                    <div class="pl-0 mb-4 pt-0 content footer flex-column flex-center-start">
                      <div class="scroll"></div>
                      <textarea id="footer" class="content pl-4 pr-4 pt-2 pb-2" placeholder="Footer" name="footer"
                        maxlength="500" [(ngModel)]="templates.new.footer" [rows]="3" (focus)="setFocus('footer')"
                        #templateFooter></textarea>
                    </div>
                    <!-- End Footer -->
                  </div>

                  <!-- Google {{'Review' | translate}} Section Starts -->
                  <div class="template flex-column flex-start google-review-wrapper"
                    *ngIf="templates.key === 'GOOGLE_REVIEW'">
                    <div class="google-review-inner">
                      <!-- Start Content -->
                      <section>
                        <div class="form-group mb-2">
                          <input id="templateSubject" class="google-review-subject" type="text" name="templateSubject"
                            maxlength="45" [(ngModel)]="templates.new.subject" (focus)="setFocus('subject')"
                            #templateSubject required />
                        </div>

                        <textarea id="templateContent" placeholder="Message body"
                          class="content p-4 google-review-message" name="templateContent" maxlength="300"
                          [rows]="templates.key === templateConstant?.reminder ? 7: 5"
                          [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                          required></textarea>

                        <div class="text-center mt-2 goolge-color-button">
                          <button disabled type="button" class="disabled action action-confirm width-auto">
                            <div class="google-color-wrapper mr-1">
                              <i class="fab fa-google"></i>
                            </div>
                            Donnez-nous votre avis sur Google
                          </button>
                        </div>
                      </section>
                      <!-- End Content -->
                    </div>
                  </div>
                  <!-- Google {{'Review' | translate}} Section Ends -->

                  <div>
                    <ul class="tag-list">
                      <li class="tag-item" *ngFor="let tag of tags" (click)="handleInsertTag(tag.value)">{{tag.label}}
                      </li>
                    </ul>
                  </div>

                </div>
              </div>
            </div>

            <div class="ui-g-12 text-right">
              <button class="btn btn-secondary btn-submit mr-2" type="button" (click)="restoreDefault()">
                {{'Restore Default' | translate}}
              </button>

              <button [disabled]="!appointmentForm.valid" class="btn btn-primary btn-submit" type="submit">
                Save
              </button>
            </div>
          </form>
          <!-- End Email Template -->


          <!-- Start SMS Template -->
          <form [hidden]="activeTab === 0" class="ui-g company-profile-form" (ngSubmit)="onSubmit()"
            #appointmentForm="ngForm">
            <div class="ui-g-12">
              <label for="templateContent" class="" *ngIf="excludedTemplates()">Message</label>
              <div class="form-group" pTooltip="{{'This text can be edited from email template.' | translate}}"
                tooltipPosition="top">
                <div class="template-view">
                  <div class="template flex-column flex-start">
                    <!-- Start Content -->
                    <section>
                      <textarea id="templateContent" placeholder="Message body"
                        pTooltip="{{'This text can be edited from email template.' | translate}}"
                        class="content p-4 not-allowed" name="templateContent" maxlength="2000"
                        [rows]="templates.key === templateConstant?.reminder ? 7: 5" [disabled]="true"
                        [(ngModel)]="templates.new.contents" (focus)="setFocus('contents')" #templateTextArea
                        required></textarea>
                    </section>
                    <!-- End Content -->

                    <!-- Start Footer -->
                    <!-- New Appointment -->
                    <div *ngIf="
          templates.key === templateConstant?.confirmation ||
          templates.key === templateConstant?.reschedule ||
          templates.key === templateConstant?.reminder" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">{{'Reply "1" to confirm, "0" to cancel' | translate}}</p>
                      </footer>
                    </div>

                    <!-- Confirm Appointment -->
                    <div *ngIf="templates.key === templateConstant?.replyConfirm" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">{{'Reply "0" to cancel' | translate }}</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.setPassword" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[set_password_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.resetPassword" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[reset_password_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.welcome" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[autoleap_app_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.inspection" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_inspection_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.estimate_approval_reminder"
                      class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_estimate_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.estimate" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_estimate_link]</p>
                      </footer>
                    </div>

                    <div
                      *ngIf="templates.key === templateConstant?.invoice || templates.key === templateConstant?.invoice_vehicle_pickup"
                      class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_invoice_link]</p>
                      </footer>
                    </div>

                    <div
                      *ngIf="templates.key === templateConstant?.review_request || templates.key === templateConstant?.review_reminder || templates.key === templateConstant?.review_request_google || templates.key === templateConstant?.review_reminder_google"
                      class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_review_link]</p>
                      </footer>
                    </div>

                    <div *ngIf="templates.key === templateConstant?.receipt" class="not-allowed pl-4 pb-2 pt-2">
                      <footer class="action-group">
                        <p class="m-0">[view_receipt_link]</p>
                      </footer>
                    </div>


                    <div class="pl-0 mb-4 pt-0 content footer flex-column flex-center-start not-allowed">
                      <div class="scroll"></div>
                      <textarea id="smsContents" class="content pl-4 pr-4 pt-2 pb-2" name="smsFooter" maxlength="500"
                        placeholder="Footer" [(ngModel)]="templates.new.smsFooter" [rows]="3"
                        (focus)="setFocus('smsFooter')" #smsFooter></textarea>
                    </div>
                    <!-- End Footer -->
                  </div>

                  <div>
                    <ul class="tag-list">
                      <li class="tag-item" *ngFor="let tag of tags" (click)="handleInsertTag(tag.value)">{{tag.label}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g-12 text-right">
              <button class="btn btn-secondary btn-submit mr-2" type="button" (click)="restoreDefault()">
                {{'Restore Default' | translate}}
              </button>
              <button [disabled]="!appointmentForm.valid" class="btn btn-primary btn-submit" type="submit">
                Save
              </button>
            </div>
          </form>
          <!-- End SMS Template -->
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
